import { ClackSkuConfig } from '../models/clack-data.model';

export function isValidClackSkuConfig(config: ClackSkuConfig): boolean {
  const { targetQuantity, minimumTaskQuantity } = config;

  return (
    !!config.sku.trim() &&
    Number.isInteger(targetQuantity) &&
    Number.isInteger(minimumTaskQuantity) &&
    (targetQuantity ?? -1) >= 0 &&
    (minimumTaskQuantity ?? 0) > 0
  );
}

export function calculateClackTaskQuantity(
  config: ClackSkuConfig,
  groceryQuantity: number
): number {
  if (!isValidClackSkuConfig(config) || !Number.isFinite(groceryQuantity)) {
    return 0;
  }

  const targetQuantity = config.targetQuantity as number;
  const minimumTaskQuantity = config.minimumTaskQuantity as number;

  // Match the release calculator: MAX(min production, target - inventory).
  // Open tasks are informational. Even at/above target, suggest the min batch.
  return Math.ceil(
    Math.max(targetQuantity - groceryQuantity, minimumTaskQuantity)
  );
}
